<template>
  <div v-if="$store.isLogin">
    <tags class="tags-container" :visitedFiles="visitedFiles" :selectedFile.sync="selectedFile"
      :bucketInfo="bucketInfoProxy" :domainSetting="domainSetting" @select-tag="onSelectTag" @close-tag="onCloseTag"
      @save-tag="onSaveFile" @on-dropmenu="onDropmenuEvent"></tags>
    <breadcrumb class="breadcrumb-container" :selectedFile="selectedFile"></breadcrumb>
    <div class="editor-main-container" ref="editorMain">
      <template v-for="(file, index) in visitedFiles">
        <eidor-main v-show="file.key === selectedFile.key" :key="file.key" :ref="`editor${index}`" :fileInfo="file"
          :bucketInfo="bucketInfoProxy" :rectSize="editorMainRectSize"
          @file-change="updateSelectedFile($event, index)" />
      </template>
    </div>

    <!-- 未保存关闭弹窗 -->
    <exit-save :show.sync="dialogShow.exitSave" @save="saveFileAndCloseTag" @unsave="onCloseFile(selectedFileIndex)" />
    <!-- 另存为重命名弹窗 -->
    <x-rename :show.sync="dialogShow.rename" :filename="selectedFile && selectedFile.key" @submit="onSaveAs" />
    <!-- 预览域名配置弹窗 -->
    <previewDomainSetting :show.sync="dialogShow.previewDomain" :bucketInfo.sync="bucketInfoProxy"
      @submit="onSaveDomain" />
    <!-- 静态网站配置弹窗 -->
    <staticWebsiteSetting :show.sync="dialogShow.staticWebsite" :bucketInfo.sync="bucketInfoProxy" />
    <importResource :show.sync="dialogShow.import" :bucketInfo.sync="bucketInfoProxy" ></importResource>
  </div>
</template>

<script>
import tags from '@/components/desktop/editor/fileTags/tags.vue';
import breadcrumb from '@/components/desktop/editor/fileTags/breadcrumb.vue';
import eidorMain from '@/components/desktop/editor/fileTags/eidorMain.vue';
import exitSave from '@/components/dialog/others/editor/exitSave.vue';
import XRename from '@/components/dialog/others/editor/rename.vue';
import previewDomainSetting from '@/components/dialog/others/editor/previewDomainSetting.vue';
import staticWebsiteSetting from '@/components/dialog/others/editor/staticWebsiteSetting.vue';
import importResource from '@/components/dialog/others/editor/importResource.vue';

import eventProxy from '@/scripts/tools/eventProxy';
import storage from '@/scripts/tools/storage';
import { getInnerProps } from '@/scripts/tools/utils';

export default {
  components: {
    tags,
    breadcrumb,
    eidorMain,
    exitSave,
    XRename,
    previewDomainSetting,
    staticWebsiteSetting,
    importResource,
  },
  props: {
    fileItem: Object,
    bucketInfo: Object,
  },
  data() {
    return {
      visitedFiles: [], // 编辑中的文件列表
      filesSet: new Set(), // 保存不重复的对象键
      selectedFile: {}, // 当前选中的文件
      selectedFileIndex: -1, // 当前选中的文件 索引
      editorMainRectSize: {
        height: 0,
        width: 0,
      },
      domainSetting: {},

      dialogShow: {
        exitSave: false, // 未保存警告弹窗
        rename: false, // 另存为重命名弹窗
        previewDomain: false, // 预览域名配置弹窗
        staticWebsite: false, // 静态网站配置弹窗
        import: false, // 导入资源
      },
    };
  },
  computed: {
    bucketInfoProxy: getInnerProps('bucketInfo'),
  },
  watch: {
    fileItem(val) {
      const currFile = val;
      this.selectedFile = currFile;
      const currFileKey = currFile.key;
      if (!this.filesSet.has(currFileKey)) {
        currFile.unsaved = false;
        this.visitedFiles.push(currFile);
        this.filesSet.add(currFileKey);
      }
      const clientSize = {
        height: document.body.clientHeight,
        width: document.body.clientWidth,
      };
      this.renderEditorMainRectSize(clientSize);
    },
  },
  mounted() {
    this.renderEditorMainRectSize();
    eventProxy.on('winResize', this.renderEditorMainRectSize);
    eventProxy.on('command.delete', this.closeTags);
  },
  methods: {
    onSelectTag(index) {
      this.selectedFile = this.visitedFiles[index];
    },
    onCloseTag(index) {
      if (!this.selectedFile.unsaved) {
        this.onCloseFile(index);
        return;
      }

      this.selectedFileIndex = index;
      this.dialogShow.exitSave = true;
    },
    closeTags(list) {
      list.forEach(file => {
        if (this.filesSet.has(file.key)) {
          let index = 0;
          for (; index < this.visitedFiles.length; index++) {
            const visitFile = this.visitedFiles[index];
            if (file.key === visitFile.key) break;
          }
          this.onCloseFile(index);
        }
      });
    },
    onCloseFile(index) {
      const [tag] = this.visitedFiles.splice(index, 1);
      this.filesSet.delete(tag.key);
      if (!this.visitedFiles.length) {
        this.selectedFile = {};
      } else if (tag.key === this.selectedFile.key) {
        this.onSelectTag(this.visitedFiles.length - 1);
      }
    },
    onSaveFile(index) {
      const editorEl = this.$refs[`editor${index}`][0];
      editorEl.saveFile();
    },
    onSaveAs(name) {
      const index = this.selectedFileIndex;
      const editorEl = this.$refs[`editor${index}`][0];
      editorEl.saveFile(false, name);
      // TODO：另存为之后要刷新一下侧边栏列表
      eventProxy.emit('saveAs', name);
    },
    onSaveDomain(domainSetting) {
      storage.add('domainSetting', domainSetting);
      this.domainSetting = domainSetting;
    },
    saveFileAndCloseTag() {
      const index = this.selectedFileIndex;
      this.onSaveFile(index);
      this.onCloseFile(index);
    },
    updateSelectedFile(file, index) {
      if (file.key === this.selectedFile.key) {
        this.selectedFile = file;
      }
      this.$set(this.visitedFiles, index, file);
    },
    getBucketWebsite() {},
    onDropmenuEvent({ action, index }) {
      this.selectedFileIndex = index;
      switch (action) {
        case 'saveAs':
          this.dialogShow.rename = true;
          break;
        case 'domainSetting':
          this.dialogShow.previewDomain = true;
          break;
        case 'staticSetting':
          this.dialogShow.staticWebsite = true;
          break;
        case 'import':
          this.dialogShow.import = true;
          break;
        default:
          break;
      }
    },
    renderEditorMainRectSize(clientSize) {
      if (!this.$refs.editorMain) return;
      const { clientHeight, clientWidth } = this.$refs.editorMain;
      if (Object.keys(this.selectedFile).length > 0) {
        this.editorMainRectSize = {
          height: clientSize.height - 80,
          width: clientWidth,
        };
      } else {
        this.editorMainRectSize = {
          height: clientHeight,
          width: clientWidth,
        };
      }
    },
  },
};
</script>

<style>
</style>
